import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';

export default function SundayDonutChart({ sundays, selectedSunday }) {
  const [chartData, setChartData] = useState({ series: [], options: {} });

  useEffect(() => {
    if (!sundays || !sundays.length) return;

    const sunday = selectedSunday ?
      sundays.find((d) => new Date(d.date).getTime() === new Date(selectedSunday).getTime()) :
      sundays[sundays.length - 1]; // par défaut le plus récent

    if (!sunday) return;

    const series = sunday.slots.map((sl) => sl.count);
    const labels = sunday.slots.map((sl) => `${sl.slot}h`);

    const options = {
      chart: { type: 'donut' },
      labels,
      states: {
        hover: {
          filter: {
            type: 'none',
            value: 0.15
          }
        },
        active: {
          filter: {
            type: 'none',
            value: 0.15
          }
        }
      },
      dataLabels: {
        enabled: false
      },
      legend: {
        position: 'bottom',
        horizontalAlign: 'center',
        fontSize: '14px',
        markers: { width: 10, height: 10, offsetX: -2 },
        responsive: [
          {
            breakpoint: 768,
            options: {
              fontSize: '12px',
              markers: { width: 8, height: 8 },
              offsetY: 0
            }
          }
        ]
      },
      title: {
        text: `${dayjs(sunday.date).format('DD MMMM YYYY').toUpperCase()}`,
        align: 'center'
      },
      stroke: {
        show: true,
        width: 5,
        colors: '#fff'
      },
      colors: ['#e2a03f', '#5c1ac3', '#e7515a'],
      plotOptions: {
        pie: {
          donut: {
            size: '65%',
            background: 'transparent',
            labels: {
              show: true,
              name: {
                show: true,
                fontSize: '29px',
                offsetY: -10
              },
              value: {
                show: true,
                fontSize: '26px',
                color: undefined,
                offsetY: 16,
                formatter: (val) => val
              },
              total: {
                show: true,
                label: 'Total',
                color: '#888ea8',
                fontSize: '29px',
                formatter: (w) => w.globals.seriesTotals.reduce((a, b) => a + b, 0)
              }
            }
          }
        }
      }
    };

    setChartData({ series, options });
  }, [sundays, selectedSunday]);

  return (
    <ReactApexChart
      series={chartData.series}
      options={chartData.options}
      type='donut'
      width='116%'
    />

  );
}
